export const TABLE_ALIGNMENT_CLASSES = [
    'fr-table-align-left',
    'fr-table-align-center',
    'fr-table-align-right',
];

export const applyAlignedTableMargins = (table: HTMLTableElement) => {
    if (table.classList.contains('fr-table-align-left')) {
        table.style.marginLeft = '0px';
        table.style.marginRight = 'auto';
        return;
    }

    if (table.classList.contains('fr-table-align-center')) {
        table.style.marginLeft = 'auto';
        table.style.marginRight = 'auto';
        return;
    }

    if (table.classList.contains('fr-table-align-right')) {
        table.style.marginLeft = 'auto';
        table.style.marginRight = '0px';
        return;
    }

    table.style.marginLeft = '';
    table.style.marginRight = '';
};

const hasTableAlignmentClass = (table: HTMLTableElement) =>
    TABLE_ALIGNMENT_CLASSES.some((className) =>
        table.classList.contains(className)
    );

export const applyDefaultCenterAlignment = (table: HTMLTableElement | null) => {
    if (!table || hasTableAlignmentClass(table)) {
        return;
    }

    table.classList.add('fr-table-align-center');
    applyAlignedTableMargins(table);
};

export const applyDefaultCenterAlignmentToAllTables = (
    editorRoot: Element | null
) => {
    if (!editorRoot) {
        return;
    }

    editorRoot.querySelectorAll('table').forEach((table) => {
        applyDefaultCenterAlignment(table as HTMLTableElement);
    });
};
